import { createApiRef } from '@backstage/frontend-plugin-api';
import { CalendarApi } from './types';

export const calendarApiRef = createApiRef<CalendarApi>().with({
  id: 'plugin.community-calendar.client',
  pluginId: 'community-calendar',
});
